import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Image from "../image/image";
import {
  createMarkup,
  getClearCartQuery,
  showSpinner,
  hideSpinner,
  getCookieValue,
} from "../../../utils/helperServices";
import ajaxService from "../../../utils/ajaxServices";
import { connect } from "../../../components/atoms/DependencyHelper";
import { showGuestCart } from "../../../Redux/actions/cartAction";
import { memorizeSelectedPreference } from "../../../Redux/actions/checkoutPageErorAction";
import styles from "./CheckoutPageError.module.scss";
import * as Analytics from "../../../services/analyticsUtag";

const CheckoutPageError = ({
  type,
  title,
  desc,
  className,
  primaryLabel,
  primaryUrl,
  secondaryLabel,
  secondaryUrl,
  handlePrimaryClick,
  handleSecondaryClick,
  imgUrl,
  pageName,
  pageErrorType,
  id,
  additionalUtagData,
  dividerLine,
  subTitle,
  subDesc,
  ctaTitle,
  disablePrimary,
  preferences,
  defaultPreference,
  dealProducts,
  cartItems,
  showGuestCart,
  memorizeSelectedPreference,
  multicartFlag,
  analyticsPageErrorCode,
  analyticsPageErrorMessage,
  onceOffCartProducts
}) => {
  var btnPrimaryClass;
  const cartId = getCookieValue("cart_id");
  const [selectedPreference, setSelectedPreference] =
    useState(defaultPreference);
  const [disabledPrimary, setDisabledPrimary] = useState(disablePrimary);

  switch (type) {
    case "success":
      btnPrimaryClass = styles["p-success"];
      break;
    case "error":
      btnPrimaryClass = styles["p-error"];
      break;
    default:
      btnPrimaryClass = styles["p-default"];
      break;
  }

  useEffect(() => {
    if (pageName) {
      let errorType = pageErrorType
        ? pageErrorType
        : type == "error"
        ? "technical error"
        : type;
      memorizeSelectedPreference(undefined);

      const pageAnalyticsData = {
        page_name: `${pageName}: ${errorType}`,
      };

      if (
        errorType == "technical error" &&
        analyticsPageErrorCode &&
        analyticsPageErrorMessage
      ) {
        pageAnalyticsData.page_errors_code = analyticsPageErrorCode;
        pageAnalyticsData.page_errors = analyticsPageErrorMessage;
      }

      Analytics.view({
        page_event: "view",
        ...pageAnalyticsData,
        multicart_flag: multicartFlag ? true : false,
        ...Analytics.getUtagData([
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
          additionalUtagData,
        ]),
      });
    }
  }, []);

  const handlePreferenceChange = (id, analyticsLabel) => {
    setSelectedPreference(id);
    memorizeSelectedPreference(id);
    setDisabledPrimary(false);

    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${analyticsLabel}`,
      page_name: `${pageName}`,
    });
  };

  const primaryButtonClick = async (url) => {
    if (
      selectedPreference &&
      (selectedPreference == "once-off" || selectedPreference == "check-once-off-only") &&
      dealProducts.length > 0
    ) {
      //delete deals products from cart before redirecting user to normal checkout page
      const dealProductsIds = dealProducts.map((item) => item?.id);
      showSpinner();
      let query = getClearCartQuery(dealProductsIds);
      await ajaxService.fetchGraphQLPOSTRequest(query);
      await showGuestCart(cartId);
      hideSpinner();
    } else if (
      selectedPreference &&
      selectedPreference == "select-another-deal-dont-need-once-off" &&
      onceOffCartProducts.length > 0
    ) {
      const onceOffCartProductsIds = onceOffCartProducts.map((item) => item?.id);
      showSpinner();
      let query = getClearCartQuery(onceOffCartProductsIds);
      await ajaxService.fetchGraphQLPOSTRequest(query);
      await showGuestCart(cartId);
      hideSpinner();
    } else if (url && url === "/" && cartItems.length > 0) {
      //delete all products from cart before redirecting user to home page
      const nonVasProducts = cartItems.filter(
        (item) => !item?.parent_product_sku
      );
      const cartItemsIds = nonVasProducts.map((item) => item?.id);
      showSpinner();
      let query = getClearCartQuery(cartItemsIds);
      await ajaxService.fetchGraphQLPOSTRequest(query);
      await showGuestCart(cartId);
      hideSpinner();
    }
    handlePrimaryClick(selectedPreference);
  };

  const secondaryButtonClick = async (url) => {
    if (url && url === "/" && cartItems.length > 0) {
      //delete all products from cart before redirecting user to home page
      const nonVasProducts = cartItems.filter(
        (item) => !item?.parent_product_sku
      );
      const cartItemsIds = nonVasProducts.map((item) => item?.id);
      showSpinner();
      let query = getClearCartQuery(cartItemsIds);
      await ajaxService.fetchGraphQLPOSTRequest(query);
      await showGuestCart(cartId);
      hideSpinner();
    }
    handleSecondaryClick();
  };

  return (
    <div className={`${styles["main-container"]} ${className}`}>
      {imgUrl && (
        <div className={`${styles["icon"]}`}>
          <Image img_path={imgUrl} />
        </div>
      )}
      <div className={`${styles["title"]}`}> {title} </div>
      {desc && (
        <div
          className={styles["desc"]}
          dangerouslySetInnerHTML={createMarkup(desc)}
        ></div>
      )}
      {dividerLine && <div className={styles.divider}></div>}
      {subTitle && (
        <div
          className={styles["sub-title"]}
          dangerouslySetInnerHTML={createMarkup(subTitle)}
        ></div>
      )}
      {subDesc && (
        <div
          className={styles["sub-desc"]}
          dangerouslySetInnerHTML={createMarkup(subDesc)}
        ></div>
      )}
      {ctaTitle && (
        <div
          className={styles["cta-title"]}
          dangerouslySetInnerHTML={createMarkup(ctaTitle)}
        ></div>
      )}
      {preferences.length > 0 && (
        <div className={styles["radio-buttons-wrapper"]}>
          {preferences.map((item, index) => (
            <div className={`${styles["button"]}`} key={index}>
              <input
                type="radio"
                name="preference"
                value={item.label}
                checked={selectedPreference === item.id}
                onChange={() =>
                  handlePreferenceChange(item.id, item?.analyticsLabel)
                }
              />
              <label
                onClick={() =>
                  handlePreferenceChange(item.id, item?.analyticsLabel)
                }
              >
                {item.label}
              </label>
            </div>
          ))}
        </div>
      )}
      {(primaryLabel || secondaryLabel) && (
        <div className={styles["button-wrapper"]}>
          {primaryLabel && (
            <button
              id={`primary-btn-${type}-${id}`}
              onClick={() => primaryButtonClick(primaryUrl)}
              className={`${styles.button} ${styles.primary} ${btnPrimaryClass}`}
              disabled={disabledPrimary}
            >
              {primaryLabel}
            </button>
          )}
          {secondaryLabel && (
            <button
              id={`secondary-btn-${type}-${id}`}
              onClick={() => secondaryButtonClick(secondaryUrl)}
              className={`${styles.button} ${styles.secondary}`}
            >
              {secondaryLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

CheckoutPageError.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  handlePrimaryClick: PropTypes.func,
  handleSecondaryClick: PropTypes.func,
  id: PropTypes.string,
  dividerLine: PropTypes.bool,
  disablePrimary: PropTypes.bool,
  preferences: PropTypes.array,
};

CheckoutPageError.defaultProps = {
  type: "success",
  title: "We’ll be in contact soon!",
  desc: null,
  primaryLabel: null,
  primaryUrl: null,
  secondaryLabel: null,
  secondaryUrl: null,
  handlePrimaryClick: () => {},
  handleSecondaryClick: () => {},
  imgUrl: null,
  pageName: null,
  pageErrorType: null,
  id: "0",
  dividerLine: false,
  subTitle: null,
  subDesc: null,
  ctaTitle: null,
  disablePrimary: false,
  preferences: [],
  defaultPreference: null,
  analyticsPageErrorCode: null,
  analyticsPageErrorMessage: null,
};

export default connect(null, {
  showGuestCart,
  memorizeSelectedPreference,
})(CheckoutPageError);
